import { CaretDown, CaretUp, Icon } from "@phosphor-icons/react";
import { motion } from "framer-motion";
import { useState } from "react";

interface FaqType {
  question: string;
  icon: Icon;
  answer: string;
}
const FAQItem: React.FC<{ faq: FaqType; i: number }> = ({ faq, i }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div key={i} className="flex flex-col items-start gap-5">
      <div className="p-3 bg-visaro-orange/10 rounded-full">
        <faq.icon className="text-visaro-orange" size={20} />
      </div>
      <div className="font-medium flex justify-between items-center gap-2">
        {faq.question}{" "}
        {isOpen ? (
          <CaretDown onClick={() => setIsOpen(false)} />
        ) : (
          <CaretUp onClick={() => setIsOpen(true)} />
        )}
      </div>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <div className="text-gray-500 text-base">{faq.answer}</div>
        </motion.div>
      )}
    </div>
  );
};

export default FAQItem;
